import Taskbar from '../components/Taskbar';
import AnimatedSection from '../components/AnimatedSection';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";

const AncientScrolls = () => {
  const images = [
    "/images/Ancientscrolls/ancientscroll1.jpg",
    "/images/Ancientscrolls/ancientscroll2.jpg",
    "/images/Ancientscrolls/ancientscroll3.jpg"
  ];
  const captions = ["Ancient Scroll", "Psalm 117:1-2", "Matthew 6:9-13"];

  return (
    <>
      <Taskbar />
      <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="max-[942px]:pt-8 min-[942px]:mt-[51px] text-text bg-bg">
      
          <AnimatedSection images={images} captions={captions} title="Ancient Scrolls" />
          <h2 className="text-3xl font-bold text-text mt-40 mb-7">Coming Soon...</h2>
      </div>
      </TwoColumnLayout>
    </>
  );
};

export default AncientScrolls;
